import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';
import { EquipementMetadata } from "./equipementMetadata";

export enum EquipementType {
  INDIVIDUEL = 'INDIVIDUEL',
  COLLECTIF = 'COLLECTIF'
}

@inheritSerialization(Entity)
export class Equipement extends Entity {

  @deserialize
  nom;

  @deserialize
  categorie;

  @deserialize
  type;

  @deserialize
  description;

  @deserialize
  image = {
    id: '',
    url: 'pro/images/pictos/cnl/picto-baignoire.svg'
  };

  @deserialize
  generique;

  @deserializeAs('in_bibliotheque')
  inBibliotheque;

  @deserializeAs('entretien_fait_par')
  entretienFaitPar;

  @deserializeAs('periodicite_entretien')
  periodiciteEntretien;

  @deserializeAs('conseil_mise_en_route')
  conseilMiseEnRoute;

  @deserializeAs('conseil_entretien')
  conseilEntretien;

  @deserializeAs('conseils_cas_de_panne')
  conseilsCasDePanne;

  @deserializeAs(Boolean, 'statut_publication')
  statutPublication;

  @deserialize
  reference;

  @deserializeAs('url_fabriquant')
  urlFabriquant;

  @deserialize
  notice;

  @deserializeAs('societe_equipement_partage')
  societeEquipementPartage;

  get nomCategorie(){
    return this.categorie.nom;
  }
}
